import { apiEndpoint } from "../utils/env";

async function fetchWithAuth(url, token, options = {}) {
  const headers = options.headers ? { ...options.headers } : {};
  if (token) headers["Authorization"] = `Bearer ${token}`;
  headers["Content-Type"] = headers["Content-Type"] || "application/json";
  const res = await fetch(url, { ...options, headers });
  const txt = await res.text();
  let json = null;
  try {
    json = txt ? JSON.parse(txt) : null;
  } catch {
    json = txt;
  }
  if (!res.ok) {
    const errMsg =
      json && json.message
        ? json.message
        : typeof json === "string"
          ? json
          : res.statusText;
    const error = new Error(errMsg || `Request failed: ${res.status}`);
    error.status = res.status;
    error.details = json;
    throw error;
  }
  return json;
}

export async function getGroups(token) {
  return fetchWithAuth(apiEndpoint("/api/GroupRights/GetGroups"), token, { method: "GET" });
}

export async function saveGroup(token, group) {
  return fetchWithAuth(apiEndpoint("/api/GroupRights/SaveGroup"), token, {
    method: "POST",
    body: JSON.stringify(group),
  });
}

export async function deleteGroup(token, id) {
  return fetchWithAuth(apiEndpoint(`/api/GroupRights/DeleteGroup/${id}`), token, {
    method: "DELETE",
  });
}

export async function setGroupDatabases(token, groupId, dbInfoIds) {
  return fetchWithAuth(apiEndpoint("/api/GroupRights/SetGroupDatabases"), token, {
    method: "POST",
    body: JSON.stringify({ groupId, dbInfoIds }),
  });
}
